export default "__VITE_ASSET__CsLUfke9__"